module.exports = __webpack_public_path__ + "static/media/Bacon.bef0bcce.png";